import React from "react";
import CarouselBanner from "../components/CarouselBanner";
function Home() {
  
  return (

    <div style={{ height: "90vh", margin: "0" }}>
      <CarouselBanner />
    </div>    
  );
}

export default Home;
